import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, User, Settings, BookOpen, Home } from 'lucide-react';

export const Navbar = () => {
  const { user, isAuthenticated, logout } = useAuth();

  if (!isAuthenticated) {
    return (
      <nav className="bg-discord-dark border-b border-discord-light/10">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-2">
              <BookOpen className="w-8 h-8 text-discord-blurple" />
              <span className="text-xl font-bold text-white">Storybook</span>
            </div>
            <div className="text-discord-light text-sm">
              Discord Bot Dashboard
            </div>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bg-discord-dark border-b border-discord-light/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-2">
              <BookOpen className="w-8 h-8 text-discord-blurple" />
              <span className="text-xl font-bold text-white">Storybook</span>
            </div>
            
            <div className="hidden md:flex space-x-6">
              <a href="/" className="flex items-center space-x-1 text-discord-light hover:text-white transition-colors">
                <Home className="w-4 h-4" />
                <span>Dashboard</span>
              </a>
              <a href="/characters" className="flex items-center space-x-1 text-discord-light hover:text-white transition-colors">
                <User className="w-4 h-4" />
                <span>Characters</span>
              </a>
              <a href="/settings" className="flex items-center space-x-1 text-discord-light hover:text-white transition-colors">
                <Settings className="w-4 h-4" />
                <span>Settings</span>
              </a>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <img 
                src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}
                alt={user.username}
                className="w-8 h-8 rounded-full"
                onError={(e) => {
                  e.target.src = `https://cdn.discordapp.com/embed/avatars/${user.discriminator % 5}.png`;
                }}
              />
              <div className="hidden md:block">
                <div className="text-sm font-medium text-white">{user.username}</div>
                <div className="text-xs text-discord-light">#{user.discriminator}</div>
              </div>
            </div>
            
            <button
              onClick={logout}
              className="flex items-center space-x-2 text-discord-light hover:text-discord-red transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden md:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
